"use client"

import { Loader2, Sparkles } from "lucide-react"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useTranslations } from "next-intl"


export function BusinessFactsPromptConfirmationDialog({
  open,
  onOpenChange,
  onContinue,
  onRegenerate,
  regenerating,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  onContinue: () => void
  onRegenerate: () => void
  regenerating: boolean
}) {
  const tUi = useTranslations("Onboarding.BusinessFactsPromptConfirmationDialog")

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle><span key={tUi("personalizationDetailsHaveChanged")}>{tUi("personalizationDetailsHaveChanged")}</span></AlertDialogTitle>
          <AlertDialogDescription>
            <span key={tUi("yourAgentPromptStillUsesThePreviousBusiness")}>{tUi("yourAgentPromptStillUsesThePreviousBusiness")}</span></AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onContinue} disabled={regenerating}>
            <span key={tUi("continueWithoutReGenerating")}>{tUi("continueWithoutReGenerating")}</span></AlertDialogCancel>
          <AlertDialogAction onClick={onRegenerate} disabled={regenerating}>
            {regenerating ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Sparkles className="mr-2 h-4 w-4" />
            )}
            <span key={regenerating ? tUi("reGenerating") : tUi("reGeneratePrompt")}>{regenerating ? tUi("reGenerating") : tUi("reGeneratePrompt")}</span>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
